import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

import { createElement, PropTypes } from 'rlink-react';
import getGdprConsent from 'rlink-cookies/getGdprConsent';
import setGdprConsent from 'rlink-cookies/setGdprConsent';
import { COOKIE_POLICY_URL } from 'rlink-cookies/constants';

import themeable from 'rlink-theme/themeable';

export default function GdprCookieConsent ({ theme, onAccept }, {buildContext = {appName: '', gdprCookieVersion: null}}) {
  let consent = getGdprConsent(buildContext.appName, buildContext.gdprCookieVersion);
  if (consent) {
    return null;
  }
  return (
    <div className={theme.ConsentContainerOverlay}>
      <div className={theme.ConsentContainer}>
        <div className={theme.MessageContainer}>
          <div className={theme.Message}>
            <span>
              <FormattedHTMLMessage
                id="ui.text.description.GDPR_COOKIE_POLICY"
                defaultMessage={'Cookies help us deliver our services and provide personalised experiences. By using this website, you agree to our use of cookies. You can find out how to manage your preferences in relation to our use of cookies at <a class="{theme}" rel="noopener" target="_blank" href="{url}">Cookie Policy</a>'}
                description="Cookie policy message that appears on an overlay. Do not change the <a> tags surrounding the text, just translate what is inside the <a> tags."
                values={{
                  url: COOKIE_POLICY_URL,
                  theme: theme.MessageLink,
                }} />
            </span>
          </div>
          <div className={theme.AcceptButtonContainer}>
            <button
              onClick={() => {
                setGdprConsent(buildContext.appName, buildContext.gdprCookieVersion);
                onAccept();
              }}
              className={theme.AcceptButton}>
              <FormattedMessage
                id="ui.label.button.GDPR_COOKIE_POLICY_ACCEPT"
                defaultMessage="Accept"
                description="Cookie policy accept button that appears on an overlay." />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

GdprCookieConsent.propTypes = {
  onAccept: PropTypes.func,
};

GdprCookieConsent.contextTypes = {
  buildContext: PropTypes.any,
};

themeable(GdprCookieConsent, {
  classes: [
    'ConsentContainerOverlay',
    'ConsentContainer',
    'MessageContainer',
    'AcceptButtonContainer',
    'AcceptButton',
    'Message',
    'MessageLink',
  ],
});



// WEBPACK FOOTER //
// ./lib/rlink-cookies/components/GdprCookieConsent.jsx